import React from 'react';
import { Navigate } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3146, { U3146ROLES } from './U3146';
import U3146CloseInactiveWizardPage from './components/wizard/U3146CloseInactiveWizardPage';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  children?: RouteObject[];
}

const U3146CloseInactiveWizardRoute: React.FC = () => {
  return <U3146CloseInactiveWizardPage />;
};

const U3146Routes: RouteObject[] = [
  {
    path: 'U3146',
    element: <U2000RequireRole allowedRoles={[U3146ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3146 />,
        children: [
          { path: 'close-inactive-wizard', element: <U3146CloseInactiveWizardRoute /> },
          { path: '*', element: <Navigate to="/U3121" replace /> },
        ],
      },
    ],
  },
];

export default U3146Routes;
